export default __webpack_public_path__ + "close.31b03209.svg";